import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { defineMessages, useIntl } from 'react-intl';
import TextareaAutosize from 'react-textarea-autosize';
import { debounce } from 'lodash';

import { tokens } from '@companycam/slab';

import useSubtaskUpdateAnswerChoice from './hooks/useSubtaskUpdateAnswerChoice';

const OpenTextAreaInput = styled(TextareaAutosize)`
  display: inline-block;
  min-width: 250px;
  padding: 0;
  margin: 0 0 -4px;
  padding: ${tokens.size_spacing_s}px ${tokens.size_spacing_m - 4}px;
  border: 1px solid var(--cc_color_border_input_inactive);
  border-radius: var(--cc_size_border_radius_m);
  font-family: 'Averta', system-ui, sans-serif;
  line-height: ${tokens.size_text_l + 2}px;
  text-decoration-thickness: 1px;
  resize: none;
`;

const messages = defineMessages({
  placeholder: {
    id: 'Project.taskList.subTasks.label.openTextAnswerInputPlaceholder',
    defaultMessage: 'Add Response...',
    description: 'Placeholder text for subtask open text answer label',
  },
  openTextAnswerInputLabel: {
    id: 'Project.taskList.subTasks.label.openTextAnswerInputLabel',
    defaultMessage: 'Text Answer Input',
    description: 'Aria label for open text answer input',
  },
});

const OpenTextAnswerInput = ({ subtask, listId, isTemplate }) => {
  const { formatMessage } = useIntl();
  const [openTextAnswer, setOpenTextAnswer] = useState(subtask.answerText);

  const updateSubtaskAnswerChoice = useSubtaskUpdateAnswerChoice({
    listId,
  });

  const handleUpdateAnswer = (answer) => {
    updateSubtaskAnswerChoice({
      variables: {
        input: {
          id: subtask.id,
          answerText: answer,
        },
      },
    });
  };

  const handleUpdateAnswerDebounce = useCallback(
    debounce(handleUpdateAnswer, 500),
    [],
  );

  return (
    <OpenTextAreaInput
      aria-label={formatMessage(messages.openTextAnswerInputLabel)}
      value={openTextAnswer}
      placeholder={formatMessage(messages.placeholder)}
      disabled={isTemplate}
      onChange={(e) => {
        const updatedOpenTextAnswer = e.target.value;
        setOpenTextAnswer(updatedOpenTextAnswer);
        handleUpdateAnswerDebounce(updatedOpenTextAnswer);
      }}
      onBlur={() => {
        if (openTextAnswer !== subtask.answerText) {
          handleUpdateAnswer(openTextAnswer);
        }
      }}
    />
  );
};

OpenTextAnswerInput.propTypes = {
  listId: PropTypes.string,
  isTemplate: PropTypes.bool,
  subtask: PropTypes.shape({
    id: PropTypes.string,
    answerText: PropTypes.string,
    listId: PropTypes.string,
  }),
};

export default OpenTextAnswerInput;
